import { render, staticRenderFns } from "./activityExams.html?vue&type=template&id=701fe864&external"
import script from "./activityExams.vue?vue&type=script&lang=js"
export * from "./activityExams.vue?vue&type=script&lang=js"
import style0 from "./activityExams.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports